<template>
  <v-dialog
    :value="value" @input="input => $emit('input', input)"
    width="500"
  >
    <v-card class="flex-column d-flex pa-7 pt-10 pb-20">
      <div class="d-flex align-center justify-center">
        <v-img :src="icon" style="max-width: 80px"></v-img>
        <div class="ml-8">
          <slot></slot>
        </div>
      </div>
      <div class="d-flex justify-end mt-5">
        <v-btn v-if="cancel" depressed outlined @click="$emit('input', false)" class="mr-4">Cancelar</v-btn>
        <v-btn style="width: 100px" depressed color="light-blue" @click="$emit('ok')" dark>OK</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    cancel: Boolean,
    value: Boolean,
    icon: String
  }
}
</script>

<style lang="scss" scoped>

</style>